// extracted by mini-css-extract-plugin
module.exports = {"BigTitle":"styles_BigTitle__1l60_","titleVariable":"styles_titleVariable__x5t4R"};